/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eg_YourbrandcomInputs */

const en_eg_yourbrandcom = /** @type {(inputs: Eg_YourbrandcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. yourbrand.com`)
};

const es_eg_yourbrandcom = /** @type {(inputs: Eg_YourbrandcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ej. tumarca.com`)
};

const fr_eg_yourbrandcom = /** @type {(inputs: Eg_YourbrandcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. votremarque.com`)
};

const de_eg_yourbrandcom = /** @type {(inputs: Eg_YourbrandcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. deinemarke.com`)
};

const ja_eg_yourbrandcom = /** @type {(inputs: Eg_YourbrandcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例: yourbrand.com`)
};

const zh_eg_yourbrandcom = /** @type {(inputs: Eg_YourbrandcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例如：yourbrand.com`)
};

const ar_eg_yourbrandcom = /** @type {(inputs: Eg_YourbrandcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مثال: yourbrand.com`)
};

const id_eg_yourbrandcom = /** @type {(inputs: Eg_YourbrandcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mis. merekanda.com`)
};

const it_eg_yourbrandcom = /** @type {(inputs: Eg_YourbrandcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`es. iltuobrand.com`)
};

const ru_eg_yourbrandcom = /** @type {(inputs: Eg_YourbrandcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`например, yourbrand.com`)
};

const pt_eg_yourbrandcom = /** @type {(inputs: Eg_YourbrandcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. suamarca.com`)
};

const ko_eg_yourbrandcom = /** @type {(inputs: Eg_YourbrandcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`예: yourbrand.com`)
};

/**
* | output |
* | --- |
* | "e.g. yourbrand.com" |
*
* @param {Eg_YourbrandcomInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const eg_yourbrandcom = /** @type {((inputs?: Eg_YourbrandcomInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eg_YourbrandcomInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eg_yourbrandcom(inputs)
	if (locale === "es") return es_eg_yourbrandcom(inputs)
	if (locale === "fr") return fr_eg_yourbrandcom(inputs)
	if (locale === "de") return de_eg_yourbrandcom(inputs)
	if (locale === "ja") return ja_eg_yourbrandcom(inputs)
	if (locale === "zh") return zh_eg_yourbrandcom(inputs)
	if (locale === "ar") return ar_eg_yourbrandcom(inputs)
	if (locale === "id") return id_eg_yourbrandcom(inputs)
	if (locale === "it") return it_eg_yourbrandcom(inputs)
	if (locale === "ru") return ru_eg_yourbrandcom(inputs)
	if (locale === "pt") return pt_eg_yourbrandcom(inputs)
	return ko_eg_yourbrandcom(inputs)
});